import React from 'react';
import './/StyleComponents/HomeTechnicalSkills.css';




const HomeTechnicalSkills = () => {

    return (
        <div>
            <div className="HomeTechnicalSkillsContainer">
                <h1>Technical Skills</h1>

                <h3>Programming</h3>
                <ul>
                    <li>Java</li>
                    <li>Python</li>
                    <li>C / C++</li>
                    <li>PHP</li>
                    <li>JavaScript</li>
                    <li>TypeScript</li>
                    <li>HTML & CSS</li>
                    <li>jQuery</li>
                    <li>Microsoft Azure</li>
                    <li>Postman</li>
                    <li>Selenium</li>
                </ul>
                <h3>Frameworks & Libraries</h3>
                <ul>
                    <li>React</li>
                    <li>Laravel</li>
                    <li>Vue.js</li>
                    <li>Flask</li>
                    <li>Express.js</li>
                    <li>Three.js</li>
                </ul>
                <h3>Databases</h3>
                <ul>
                    <li>SQL (including dynamic SQL)</li>
                    <li>PostgreSQL</li>
                    <li>MongoDB</li>
                    <li>SQL Server Reporting Services (SSRS)</li>
                </ul>
                <h3>Tools</h3>
                <ul>
                    <li>WordPress</li>
                    <li>MATLAB</li>
                    <li>Octave</li>
                    <li>Blender</li>
                </ul>
            </div>

        </div>
    )
}

export default HomeTechnicalSkills;